const PublicoEnum = {
  ALUNO: 1,
  EGRESSO: 2,
  PROFESSOR: 3,
  FUNCIONARIO: 6,
  COMUNIDADE: 7,
  ALUNO_COLEGIO: 10,
  PROFESSOR_COLEGIO: 11,
  ALUNO_IDIOMAS: 12,
  ESTAGIARIO: 13,
  ALUNO_EAD: 14,
  ALUNO_POS: 15,
  VISITANTE: 17,
  RESPONSAVEL_FINANCEIRO: 18
};

export default PublicoEnum;



// WEBPACK FOOTER //
// ./src/domain/web/PublicoEnum.js